module.exports = __webpack_public_path__ + "static/assets/6e89ac4b1f3ebf0838fc26c4c5a9e847.png";